import { render, staticRenderFns } from "./districtSelect.vue?vue&type=template&id=70a087dc&scoped=true&"
import script from "./districtSelect.vue?vue&type=script&lang=js&"
export * from "./districtSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a087dc",
  null
  
)

export default component.exports